import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaSearch, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit,MdClose } from 'react-icons/md';
import styles from "./distribuidor.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalDistribuidores from './distribuidorModal';




export default function Distribuidores(props) {
    const { windowSize } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);

    const [coordinadores, setCoordinadores] = useState([]);
    const [asesores, setAsesores] = useState([]);
    const [maritalEstatus, setMaritalEstatus] = useState([]);
    const [addressTypes, setAddressTypes] = useState([]);
    const [genders, setGenders] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [questions, setQuestions] = useState([]);
    const [textSearch,setTextSearch] = useState("");
    const [textSearchPrev,setTextSearchPrev] = useState("");

    const { estados, municipios, codigos, documentTypes, referenceTypes } = useAuth();

    const columns = [
        {
            name: '',
            cell: (row) => {
                return (
                    <div style={{ display: "flex", position: 'sticky', left: 0, background: "white", zIndex: "1" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.distributorName, row.distributorId)}><MdDelete /></button>
                    </div>
                )
            },
            width: "100px",

        },
        {
            name: 'ID',
            selector: row => row.distributorId,
            width: "70px",
        },
        {
            name: 'Nombre',
            selector: row => row.distributorName,
            flex: "1",
            minWidth: "200px"
        },
        {
            name: 'Dirección',
            selector: row => row.address,
            flex: "1",
            minWidth: "150px"
        },
        {
            name: 'Teléfono',
            selector: row => row.stateName,
            flex: "1",
            minWidth: "100px"
        },

        {
            name: 'Estatus',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <span className={row.status ? "badge bg-success" : "badge bg-danger"}>{row.status ? "Activo" : "Inactivo"}</span>
                    </div>
                )
            },
            width: "174px",
        },

    ];

    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "Esta segur@ que desea eliminar el cliente " + userName + "?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                api("/Distributors" + SERVICE.detelePersonalData + `?Id=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }

    const handleGetOffice = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId
                        });

                    }
                }
                setOfices(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetQuestions = () => {
        api(SERVICE.getQuestionsByArea + "CLT_WARRANTY")
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);

                    }
                }
                setQuestions(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetAsesortes = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName
                        });

                    }
                }
                setAsesores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetAddressType = () => {
        api(SERVICE.getTiposVivienda)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setAddressTypes(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetCoordinadores = () => {
        api(SERVICE.getCordinadoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId,
                            postalCodeId: element.postalCodeId,
                            centralOfficeId: element.centralOfficeId
                        });

                    }
                }
                setCoordinadores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetMarital = () => {
        api(SERVICE.getMaritalEstatus)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setMaritalEstatus(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetGenders = () => {
        api(SERVICE.getGenders)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setGenders(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdate = () => {
        let URL = "/Distributors" + SERVICE.getPersonal + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if(textSearch!=""){
            URL = URL +`&TextSearch=${textSearch}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push(element);

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdateNosearch = () => {
        let URL = "/Distributors" + SERVICE.getPersonal + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push(element);

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        if (codigos.length > 0 && municipios.length > 0 && ofices.length > 0 && estados.length > 0 && coordinadores.length > 0) {
            handleUpdate();
        }
    }, [ofices, coordinadores, page, perPage])
    useEffect(() => {
        handleGetOffice();
        handleGetCoordinadores();
        handleGetMarital();
        handleGetGenders();
        handleGetAsesortes();
        handleGetQuestions();
        handleGetAddressType();
    }, [])
    return (
        <>
            <WindowLayout
                title="DISTRIBUIDORES"
                route={["Prestamos", "Distribuidores"]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>
                    <div class="input-group flex-nowrap" style={{ marginBottom: "10px", width: "500px" }}>
                        <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                        <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                    </div>
                    <div class="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                        <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                        }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>
            <ModalDistribuidores
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                handleUpdate={handleUpdate}
                municipios={municipios}
                estados={estados}
                codigos={codigos}
                ofices={ofices}
                coordinadores={coordinadores}
                maritalEstatus={maritalEstatus}
                genders={genders}
                asesores={asesores}
                addressTypes={addressTypes}
                documentTypes={documentTypes}
                referenceTypes={referenceTypes}
                questions={questions}
            />
        </>
    );
} 